import * as constants from '../constants';

import { LandingPagesAction } from '../actions/landingPages';
import * as types from '../types';

const getDefaultState = () => ({
    related_links: [],
    description: '',
    title: '',
    region: '',
    bucket: '',
    bucket_srp_url: '',
    venue_data: [],
    hero_image: '',
    market: '',
});

export function barnVenue(state: types.BucketLandingPage = getDefaultState(), action: any) {
    switch (action.type) {
        case constants.LOAD_BARN_PAGE_DATA:
            return { ...state, ...action.payload };
        default:
            return state;
    }
}

export default barnVenue;
